var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M9.283 2.7c-2.595-.758-5.314.702-6.08 3.246-.765 2.541.703 5.221 3.295 5.98 1.166.34 2.323.467 3.245.11a.5.5 0 0 1 .532.11l5.431 5.354H18v-2.247l-5.428-5.351a.5.5 0 0 1-.14-.447l.132-.721.013-.054c.765-2.54-.702-5.221-3.294-5.98M2.246 5.659C3.173 2.578 6.452.83 9.563 1.74c3.105.908 4.89 4.125 3.98 7.2l-.08.434 5.388 5.312a.5.5 0 0 1 .15.357V18a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.35-.144l-5.359-5.282c-1.16.338-2.448.141-3.575-.189-3.114-.91-4.9-4.143-3.971-7.227ZM7.5 7.5A.5.5 0 0 1 8 7h.101a.5.5 0 0 1 0 1h-.1a.5.5 0 0 1-.5-.5Z",
    clipRule: "evenodd"
  })));
};
export default SvgKey;